export const BATCH_KEY_LIMIT = 500;

export const chunk = <T>(items: readonly T[], size: number): T[][] => {
	if (size <= 0) throw new Error("chunk size must be a positive integer");
	const batches: T[][] = [];
	for (let index = 0; index < items.length; index += size) {
		batches.push(items.slice(index, index + size));
	}
	return batches;
};

const fetchInBatches = async <TNode>(
	keys: readonly string[],
	fetchBatch: (batchKeys: string[]) => Promise<TNode[]>,
	identityOf: (node: TNode) => string,
	batchSize: number = BATCH_KEY_LIMIT
): Promise<TNode[]> => {
	const merged = new Map<string, TNode>();
	for (const batch of chunk(keys, batchSize)) {
		const nodes = await fetchBatch(batch);
		for (const node of nodes) {
			merged.set(identityOf(node), node);
		}
	}
	return [...merged.values()];
};

export default fetchInBatches;
